import React from "react";
import { connect } from "react-redux";
import { noop, get } from "lodash";
import { getEditedId } from "state/ui/dashboard-form/selectors";
import { isModalVisible } from "state/ui/selectors";
import { createCloseModalAction } from "state/ui/actions";
import Modal from "components/modal";
import { Box, Stack } from "@towersystems/towersystems-design-system";
import FormTextInput from "components/forms/form-text-input";
import FormLabel from "components/forms/form-label";
import ButtonGroup from "components/button-group";
import Button from "components/button";
import vd from "lib/vd";
import Preloader from "../../components/preloader";
import { Preview } from "./preview";
import { startEditingReport } from "state/ui/report-builder/actions";
import page from "page";
import {
  normalizedQuery,
  toDataType,
  resultToReportConfig,
  toChartType,
} from "./utils";
import { SelectChartType } from "./select-chart-type";
import "./styles.scss";

export const ModalName = "AiAssistantPopover";

const AiAssistantPopover = ({
  isVisible = false,
  closeModal = noop,
  startEditingReport,
}) => {
  const [selectedChartType, setSelectedChartType] = React.useState(undefined);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [result, setResult] = React.useState();

  const [question, setQuestion] = React.useState("");
  const title = "Ask AI Assistant";
  const description = "Describe what you want to see in the dashboard.";

  React.useEffect(() => {
    if (!result) {
      setSelectedChartType(undefined);
    } else {
      if (result.length > 0) {
        setSelectedChartType(toChartType(result[0]));
      }
    }
  }, [result]);

  const handleOnAskQuestion = () => {
    setError(null);
    setLoading(true);
    setResult(undefined);
    return vd
      .ai()
      .promptCubeJsQuestion(question)
      .then((response) => {
        if (response.queries && response.queries.length > 0) {
          setResult(response.queries.map((q) => normalizedQuery(q)));
        }
      })
      .catch((err) => {
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const previewMarkup = React.useMemo(() => {
    let content;
    if (result && result.length > 0) {
      const isCompare = result.length > 1;

      const compareDateRange = isCompare
        ? get(result[1], "timeDimensions[0].dateRange")
        : undefined;

      console.log(result[0]);
      content = (
        <Preview
          {...result[0]}
          compare={isCompare}
          //compareDateRange={compareDateRange}
          dataType={toDataType(result[0])}
          chartType={selectedChartType}
        />
      );
    }
    return content;
  }, [result, selectedChartType]);

  const handleOnOpenInEditor = () => {
    if (result && result.length > 0) {
      const report = resultToReportConfig(result[0]);
      startEditingReport(null, report);
      closeModal();
      page("/report-builder/new");
    }
  };

  const openInEditorButtonMarkup =
    result && result.length > 0 ? (
      <Button onClick={handleOnOpenInEditor}>Open in Editor</Button>
    ) : null;

  return (
    <Modal
      title={title}
      description={description}
      className="ai-assistant-modal"
      isVisible={isVisible}
      close={closeModal}
    >
      <Box padding="large">
        <Box className="ai-assistant__answer-container">
          {loading && <Preloader />}
          {error && <Box>{error}</Box>}
          {previewMarkup && (
            <SelectChartType
              onChange={setSelectedChartType}
              selected={selectedChartType}
              dataType={toDataType(result[0])}
            />
          )}
          <Box className="ai-assistant__preview">{previewMarkup}</Box>
        </Box>
        <Stack space="large">
          <FormLabel>
            Simply type a question and AI Assistant will help build a report for
            you
          </FormLabel>
          <FormTextInput
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            name="question"
            autoComplete="off"
            placeholder="Example: Revenue by month for 2024 vs 2023"
          />
          <Box display="flex" justifyContent="flexEnd">
            <ButtonGroup>
              {openInEditorButtonMarkup}
              <Button onClick={closeModal}>Cancel</Button>
              <Button
                disabled={loading || question.length === 0}
                onClick={handleOnAskQuestion}
                secondary
              >
                Ask Question
              </Button>
            </ButtonGroup>
          </Box>
        </Stack>
      </Box>
    </Modal>
  );
};

export default connect(
  (state) => ({
    isVisible: isModalVisible(ModalName)(state),
    dashboardId: getEditedId(state),
  }),
  {
    closeModal: createCloseModalAction(ModalName),
    startEditingReport,
  }
)(AiAssistantPopover);
